import { render, staticRenderFns } from "./AppListItemPlaceholder.vue?vue&type=template&id=00cae990&"
import script from "./AppListItemPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./AppListItemPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./AppListItemPlaceholder.vue?vue&type=style&index=0&id=00cae990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports